var _path, _path2, _path3, _path4, _rect, _rect2, _rect3, _rect4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMonitorDarkDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 40,
    viewBox: "0 0 47 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.7133 1.30859H1.2168V23.9205H44.7133V1.30859Z",
    fill: "#5F5F5F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.2168 1.30801V18.5941C3.00952 18.9735 4.86767 19.1829 6.77817 19.1829C18.4113 19.1829 28.2647 11.698 31.8632 1.29492H1.2168V1.30801Z",
    fill: "url(#paint0_linear)",
    fillOpacity: 0.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.57237 32.2036H17.4823L15.4672 37.5687H13.3996V39.3614H33.0804V37.5687H31.0128L28.9977 32.2036H42.9076C44.8836 32.2036 46.48 30.6072 46.48 28.6313V3.57236C46.48 1.59644 44.8836 0 42.9076 0H3.57237C1.59644 0 0 1.59644 0 3.57236V28.6182C0 30.5941 1.59644 32.2036 3.57237 32.2036ZM29.1154 37.5687H17.3907L19.4059 32.2036H27.1133L29.1154 37.5687ZM44.7265 28.6182C44.7265 29.6127 43.9283 30.4109 42.9338 30.4109H3.57237C2.57786 30.4109 1.77964 29.6127 1.77964 28.6182V24.9411H44.7134L44.7265 28.6182ZM1.79273 3.57236C1.79273 2.57786 2.59095 1.77964 3.58545 1.77964H42.9338C43.9283 1.77964 44.7265 2.57786 44.7265 3.57236V23.1615H1.79273V3.57236Z",
    fill: "#6d7177"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2533 28.9988C23.9832 28.9988 24.5749 28.407 24.5749 27.6771C24.5749 26.9472 23.9832 26.3555 23.2533 26.3555C22.5234 26.3555 21.9316 26.9472 21.9316 27.6771C21.9316 28.407 22.5234 28.9988 23.2533 28.9988Z",
    fill: "#6d7177"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 4,
    width: 26,
    height: 14,
    rx: 3,
    fill: "white",
    fillOpacity: 0.1
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 19,
    width: 40,
    height: 3,
    rx: 1,
    fill: "white",
    fillOpacity: 0.1
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 37,
    y: 4,
    width: 6,
    height: 14,
    rx: 2,
    fill: "white",
    fillOpacity: 0.1
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 4,
    width: 6,
    height: 14,
    rx: 2,
    fill: "white",
    fillOpacity: 0.1
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 16.54,
    y1: 1.29492,
    x2: 16.54,
    y2: 19.1829,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMonitorDarkDark);
export default __webpack_public_path__ + "static/media/monitor-dark-dark.079dfd3104a7e53efe5d2d02891353c3.svg";
export { ForwardRef as ReactComponent };